import { Calendar, X } from "lucide-react";
import { getTypeLabel } from "../../utils/helpers";

/**
 * Read-only detail modal for My-Escalations tab.
 *
 * Props:
 *   escalation  {object|null}
 *   onClose     {function}
 *   theme       {string}
 *   screenSize  {string}
 *   styles      {object}
 *   language    {"en"|"ar"}
 *   t           {object}
 *   StatusBadge {component}
 */
const DetailModal = ({
  escalation,
  onClose,
  theme,
  screenSize,
  styles,
  language,
  t,
  StatusBadge,
}) => {
  if (!escalation) return null;

  const readonlyBox = {
    ...styles.formInput,
    background:
      theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
    padding: "1rem 1.25rem",
    display: "flex",
    alignItems: "center",
    cursor: "default",
  };

  return (
    <div style={styles.modal} onClick={onClose}>
      <div
        style={{ ...styles.modalContent, maxWidth: "600px" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>{t.escalationDetails}</h2>
          <button style={styles.closeBtn} onClick={onClose} title={t.close}>
            <X size={screenSize === "xs" ? 20 : 24} />
          </button>
        </div>

        {/* ID & Type */}
        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>{t.escalationId}</label>
            <div style={{ ...readonlyBox, color: "#2e7cba", fontWeight: "600" }}>
              ESC-{escalation.id}
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>{t.escalationType}</label>
            <div style={readonlyBox}>
              {getTypeLabel(escalation.type, language)}
            </div>
          </div>
        </div>

        {/* Status & Date */}
        <div style={styles.formRow}>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>{t.status}</label>
            <div style={{ ...readonlyBox, padding: "0.75rem 1.25rem" }}>
              <StatusBadge status={escalation.status} />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>{t.createdDate}</label>
            <div style={readonlyBox}>
              <Calendar size={14} style={{ opacity: 0.6, marginRight: "0.5rem" }} />
              {new Date(escalation.issuedAt).toLocaleDateString()}
            </div>
          </div>
        </div>

        {/* Description */}
        <div style={styles.sectionTitle}>{t.description}</div>
        <div style={styles.formGroup}>
          <div
            style={{
              ...styles.formTextarea,
              minHeight: "120px",
              padding: "1.25rem",
              background:
                theme === "dark"
                  ? "rgba(255,255,255,0.05)"
                  : "rgba(0,0,0,0.02)",
              border: "none",
              cursor: "default",
              resize: "none",
            }}
          >
            {escalation.description || t.na}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailModal;